import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Portfolio, Attribute, ValueList } from 'src/app/models';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PortfolioService, ToastService } from 'src/app/services';

@Component({
    selector: 'app-portfolio-info',
    templateUrl: './portfolio-info.component.html',
    styleUrls: ['./portfolio-info.component.scss'],
    standalone: false
})
export class PortfolioInfoComponent implements OnInit {

  @Input() title: string;
  @Input() portfolio: Portfolio;
  @Output() sendPortfolioIdToParent: EventEmitter<string> = new EventEmitter();
  @Output() sendInvalidSelectToParent: EventEmitter<string> = new EventEmitter();
  @Output() sendAttributeInfoToParent: EventEmitter<string> = new EventEmitter();
  idExecution: string;
  isSelectedValueInvalid = false;
  invalidSelectedErrorMessage: string;

  constructor(
    private route: ActivatedRoute,
    private toastService: ToastService,
    private portfolioService: PortfolioService,
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(async (params) => {
      this.idExecution = params.get('id');
    });
  }

  /**
   * Delete aggregation
   * @param idAggregation Aggregation id
   */

  deleteAggregation(idAggregation: string) {
    this.sendPortfolioIdToParent.emit(idAggregation);
  }

  /**
   * Discriminates if you are selecting a value from a single select or a multiselect and returns the values
   * @param $event Selected options
   * @param attribute Selected Attribute
   */

  setChosenValue($event: ValueList | ValueList[], attribute: Attribute) {
    if (attribute.name === 'Ramo' || attribute.name === 'Lob') {
      this.portfolio.pristine = false;
    }
    if (attribute.isMultiSelectionAvailable) {
      attribute.chosen_values = ($event as ValueList[]).map(item => item.id);
    } else {
      attribute.chosen_values = [($event as ValueList).id];
    }
  }

  /**
   * Returns selected attributes and send values ​​with the api
   * @param attribute Selected Attribute
   */

  async sendChosenValue(attribute: Attribute) {
    const idChoosenValue = attribute.isMultiSelectionAvailable ? attribute.chosen_values.map(choosen => {
      return { id: choosen };
    }) : [{ id: attribute.chosen_values[0] || '' }];
    if (!attribute.isMultiSelectionAvailable) {
      if (!idChoosenValue.length || !idChoosenValue[0].id.length) { return; }
    }
    try {
      const response = await this.portfolioService.changeAggregationConfig(
        this.idExecution,
        attribute.name,
        this.portfolio.id,
        idChoosenValue
      );
      if ((attribute.name === 'Ramo' || attribute.name === 'Lob') && response.result_object.status) {
        this.portfolio.attribute = [this.portfolio.attribute[0], ...response.attributes];
        this.sendAttributeInfoToParent.emit(this.portfolio.id);
      }
      this.isSelectedValueInvalid = false;
      attribute.isInvalidField = false;
    } catch (error) {
      this.isSelectedValueInvalid = true;
      this.invalidSelectedErrorMessage = error.error.result_object.detail;
      attribute.isInvalidField = true;
      this.sendInvalidSelectToParent.emit('invalid');
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  /**
   * Returns selected attributes when closing the multiselect and send values ​​with the api
   * @param attribute Selected Attribute
   */

  async onClear(attribute: Attribute) {
    const idChoosenValue = attribute.isMultiSelectionAvailable ? attribute.chosen_values.map(choosen => {
      return { id: choosen };
    }) : [{ id: attribute.chosen_values[0] || '' }];
    if (!attribute.isMultiSelectionAvailable) {
      if (!idChoosenValue.length || !idChoosenValue[0].id.length) { return; }
    }
    try {
      const response = await this.portfolioService.changeAggregationConfig(
        this.idExecution,
        attribute.name,
        this.portfolio.id,
        idChoosenValue
      );
      if ((attribute.name === 'Ramo' || attribute.name === 'Lob') && response.result_object.status) {
        this.portfolio.attribute = [this.portfolio.attribute[0], ...response.attributes];
        this.sendAttributeInfoToParent.emit(this.portfolio.id);
      }
      this.isSelectedValueInvalid = false;
      attribute.isInvalidField = false;
    } catch (error) {
      this.isSelectedValueInvalid = true;
      this.invalidSelectedErrorMessage = error.error.result_object.detail;
      attribute.isInvalidField = true;
      this.sendInvalidSelectToParent.emit('invalid');
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }
}
